import React, { useState } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import is from "styled-is"
import { useTransition, useSpring, animated } from "react-spring"
import Chevron from "../../svg/chevron.svg"
import { Button, ButtonLink } from "../common"

const StyledMobileNav = styled.div`
  background: ${(props) => props.theme.colors.headerBg};
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  z-index: 99;
  padding-top: 8rem;
  padding-left: ${(props) => props.theme.padding.headerMobile};
  padding-right: ${(props) => props.theme.padding.headerMobile};
  top: 0;
  left: 0;
  nav {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  .login-button {
    background: #fff;
    color: ${(props) => props.theme.colors.headerBg};
    display: flex;
    justify-content: center;
    max-width: 200px;
  }
  .demo-button {
    background: #6eb25b;
    display: flex;
    justify-content: center;
    max-width: 200px;
  }
`

const StyledMobileSubNav = styled(StyledMobileNav)`
  background: transparent;
`

const AnimatedSubNav = animated(StyledMobileSubNav)
const AnimatedMobileNav = animated(StyledMobileNav)

const MobileNavLink = styled(Link)`
  color: #fff;
  font-weight: 600;
  font-size: 22px;
  padding: 0.8rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > svg {
    width: 0.6rem;
  }
  ${is("isBack")`
    justify-content: flex-start;
    > svg{
      transform: rotate(180deg);
      margin-right: 2rem;
    }
  `}
  ${is("isSub")`
    justify-content: flex-start;
    .gatsby-image-wrapper, img {
      width: 2rem;
      margin-right: 1rem;
    }
    border-bottom: 1px solid #3D3D3D;
    padding: 1rem 0;
    font-size: 16px;
    padding-left: 1rem;
  `}
  ${is("isFeature")`
    color: ${(props) => props.theme.colors.brandColor};
    justify-content: center;
    border-bottom: none;
    padding-left: 0;
  `}
`

const MobileSubNav = ({ isActive, activeMenu, onClose }) => {
  const transitions = useTransition(isActive, null, {
    from: { opacity: 0, transform: "translate3d(-100%, 0,0)" },
    enter: { opacity: 1, transform: "translate3d(0%, 0,0)" },
    leave: { opacity: 0, transform: "translate3d(-100%, 0,0)" },
  })

  return transitions?.map(
    ({ item, key, props }) =>
      item && (
        <AnimatedSubNav style={props} key={`subNav-${key}`}>
          {activeMenu && (
            <nav>
              <MobileNavLink as="button" isBack onClick={onClose}>
                <Chevron />
                {activeMenu?.nav_title}
              </MobileNavLink>
              {activeMenu?.page_reference?.document?.data?.nav_items?.map(
                (item) => {
                  const { nav_title, feature_link, page_reference } = item
                  return (
                    <MobileNavLink
                      to={page_reference?.url}
                      isSub
                      isFeature={feature_link === "true"}
                    >
                      {nav_title}
                    </MobileNavLink>
                  )
                }
              )}
            </nav>
          )}
        </AnimatedSubNav>
      )
  )
}

export const MobileNav = ({ items, menuState }) => {
  const [subMenu, setSubMenu] = useState(null)
  const [subActive, setSubActive] = useState(false)
  const { x } = useSpring({
    x: subMenu ? 0 : 1,
  })
  const transitions = useTransition(menuState, null, {
    from: { opacity: 0, transform: "translate3d(-100%, 0,0)" },
    enter: { opacity: 1, transform: "translate3d(0%, 0,0)" },
    leave: { opacity: 0, transform: "translate3d(-100%, 0,0)" },
  })

  return transitions.map(
    ({ item, key, props }) =>
      item && (
        <AnimatedMobileNav style={props} key={key}>
          <animated.nav
            style={{
              opacity: x.interpolate((x) => x),
            }}
          >
            {items.map((item) => {
              const { type, url } = item.page_reference
              return type === "sub_navigation" ? (
                <MobileNavLink
                  as="button"
                  onClick={() => {
                    setSubMenu(item)
                    setTimeout(() => {
                      setSubActive(true)
                    }, 100)
                  }}
                >
                  {item.nav_title} <Chevron />
                </MobileNavLink>
              ) : (
                <MobileNavLink to={url}>{item.nav_title}</MobileNavLink>
              )
            })}
            <Button
              as="a"
              href="https://go.mytrev.com/account/login"
              target="_blank"
              className="login-button"
            >
              Login
            </Button>
            <ButtonLink
              to="/signup"
              href="https://www.mytrev.com/signup"
              className="demo-button"
              onClick={() => {
                setSubActive(false)
                setTimeout(() => {
                  setSubMenu(null)
                }, 100)
              }}
            >
              Free Demo
            </ButtonLink>
          </animated.nav>
          <MobileSubNav
            isActive={subActive}
            activeMenu={subMenu}
            onClose={() => {
              setSubActive(false)
              setTimeout(() => {
                setSubMenu(null)
              }, 100)
            }}
          />
        </AnimatedMobileNav>
      )
  )
}
